export default __webpack_public_path__ + "assets/images/632c7e9f8c714168a12516adb657017e.png";